// A Qlik reload log line is "<timestamp> [<statement no.>] <text>", sometimes
// indented (seen in H2J logs); the lines that say why it failed are highlighted.
const ERROR_LINE =
  /^\s*\S+\s+(?:\d{4}\s+)?(?:Error\b|The following error occurred|Execution Failed)/i;

export type ReloadLogSegment = { text: string; error: boolean };

// The log as runs of plain lines and single error lines, so a long log renders
// as a handful of nodes instead of one per line.
export function reloadLogSegments(log: string): ReloadLogSegment[] {
  const segments: ReloadLogSegment[] = [];
  let plain: string[] = [];
  for (const line of log.split(/\r?\n/)) {
    if (!ERROR_LINE.test(line)) {
      plain.push(line);
      continue;
    }
    if (plain.length > 0) segments.push({ text: plain.join("\n"), error: false });
    plain = [];
    segments.push({ text: line, error: true });
  }
  if (plain.length > 0) segments.push({ text: plain.join("\n"), error: false });
  return segments;
}

// Saves the log the drawer already holds, as the browser's own download.
export function saveReloadLog(log: string, reloadId: string) {
  const url = URL.createObjectURL(new Blob([log], { type: "text/plain;charset=utf-8" }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `qlik-reload-${reloadId}.log`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
